import { AuthCompanyQuery } from 'dashboard-services/api/auth';
import { CommonService } from 'dashboard-services/services';

import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';

export default (() => {
  const useCreateCompany = ({ getQueryBuilder, name, users, admins, settings, authType, companyTags, companyMetadata, queryClient, onSuccess, ...rest }) =>
    useMutation({
      ...AuthCompanyQuery.QUERIES.createCompany(
        getQueryBuilder,
        {
          name,
          users,
          admins,
          settings,
          authType,
          companyTags,
          companyMetadata
        }
      ),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: AuthCompanyQuery.KEYS.SEARCH() })
        onSuccess?.()
      },
      ...rest
    })

  const useEditCompany = ({ getQueryBuilder, queryClient, name, newName, authType, companyMetadata, companyTags, metadataRemovalOption, onSuccess, ...rest }) =>
    useMutation({
      ...AuthCompanyQuery.QUERIES.editCompany(
        getQueryBuilder,
        {
          authType,
          companyMetadata,
          companyTags,
          metadataRemovalOption,
          name,
          newName
        }
      ),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: AuthCompanyQuery.KEYS.SEARCH() })
        onSuccess?.()
      },
      ...rest
    })

  const useGetCompany = ({ getQueryBuilder, companyName, ...rest }) =>
    useQuery({
      ...AuthCompanyQuery.QUERIES.getCompany(getQueryBuilder, { companyName }),
      ...rest
    })

  const useSearchCompanies = ({ query, size = CommonService.getRequestSize(), sortBy, sortOrder, tags, getQueryBuilder, shouldRefetch = true, shouldBeLimited, ...rest }) =>
    useInfiniteQuery({
      ...AuthCompanyQuery.QUERIES.searchCompanies(
        getQueryBuilder,
        {
          query: `*${query || ""}*`,
          size,
          sortBy,
          sortOrder,
          tags
        }
      ),
      initialPageParam: 0,
      getNextPageParam: CommonService.getNextPageParam,
      refetchInterval: () => !shouldRefetch || shouldBeLimited() ? undefined : 10000,
      ...rest
    })

  const useGetCurrentCompanyDataAsCsv = ({ getQueryBuilder, ...rest }) =>
    useQuery({
      ...AuthCompanyQuery.QUERIES.getCurrentCompanyDataAsCsv(getQueryBuilder),
      ...rest
    })

  const companiesTagsSelect = data => data?.pages?.flatMap(page => page?.items)?.map(item => ({ value: item?.tagName, label: item?.tagName })) || []
  const useCompanyTags = ({ getQueryBuilder, query, size = CommonService.getRequestSize() }) =>
    useInfiniteQuery({
      ...AuthCompanyQuery.QUERIES.getCompaniesTags(
        getQueryBuilder,
        {
          query: query ? `*${query}*` : "*",
          size
        }
      ),
      select: companiesTagsSelect,
      initialPageParam: 0,
      getNextPageParam: CommonService.getNextPageParam
    })

  return {
    useCreateCompany,
    useGetCompany,
    useSearchCompanies,
    useGetCurrentCompanyDataAsCsv,
    useCompanyTags,
    useEditCompany
  }
})()